import React from "react";
import axios from "axios";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Landing from "./pages/Landing";
import Frozen from "./pages/Frozen/Frozen";
import AllFrozen from "./pages/Frozen/AllFrozen";


//axios.defaults.baseURL = "http://localhost:6033/api/v1";
axios.defaults.baseURL = "https://api.chocodate.app/api/v1";
axios.defaults.withCredentials = true;

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/:qr" element={<Home />} />
        <Route path="/frozen-rhutab" element={<Frozen />} />
        <Route path="/frozen-rhutab-chocodate" element={<AllFrozen />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
